import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingCustomers: false,
  loadingCustomer: false,
  loadingCustomerCreate: false,
  loadingCustomerUpdate: false,
  loadingCustomerDelete: false,

  errorLoadingCustomers: null,
  errorLoadingCustomer: null,
  errorCreatingCustomer: null,
  errorUpdatingCustomer: null,
  errorDeletingCustomer: null,

  customers: [],
  customer: null,

  serverStatus: null,
  pagination: {},
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setLoadingCustomers(state) {
      state.loadingCustomers = true;
      state.errorLoadingCustomers = null;
    },
    setLoadingCustomer(state) {
      state.loadingCustomer = true;
      state.errorLoadingCustomer = null;
    },
    setLoadingCustomerCreate(state) {
      state.loadingCustomerCreate = true;
      state.errorCreatingCustomer = null;
    },
    setLoadingCustomerUpdate(state) {
      state.loadingCustomerUpdate = true;
      state.errorUpdatingCustomer = null;
    },
    setLoadingCustomerDelete(state) {
      state.loadingCustomerDelete = true;
      state.errorDeletingCustomer = null;
    },

    setErrorLoadingCustomers(state, { payload }) {
      state.loadingCustomers = false;
      state.errorLoadingCustomers = payload;
    },
    setErrorLoadingCustomer(state, { payload }) {
      state.loadingCustomer = false;
      state.errorLoadingCustomer = payload;
    },
    setErrorCreatingCustomer(state, { payload }) {
      state.loadingCustomerCreate = false;
      state.errorCreatingCustomer = payload;
    },
    setErrorUpdatingCustomer(state, { payload }) {
      state.loadingCustomerUpdate = false;
      state.errorUpdatingCustomer = payload;
    },
    setErrorDeletingCustomer(state, { payload }) {
      state.loadingCustomerDelete = false;
      state.errorDeletingCustomer = payload;
    },

    setCustomers(state, { payload }) {
      state.loadingCustomers = false;
      state.errorLoadingCustomers = null;
      state.customers = payload;
    },

    setCustomer(state, { payload }) {
      state.loadingCustomer = false;
      state.errorLoadingCustomer = null;
      state.customer = payload;
    },

    createCustomerSuccess(state, { payload }) {
      state.customers = [payload, ...state.customers];
      state.loadingCustomerCreate = false;
      state.errorCreatingCustomer = null;
    },

    updateCustomerSuccess(state, { payload }) {
      state.customers = state.customers.map((u) =>
        u.id === payload.id ? payload : u,
      );

      if (state.customer && state.customer.id === payload.id) {
        state.customer = payload;
      }

      state.loadingCustomerUpdate = false;
      state.errorUpdatingCustomer = null;
    },

    deleteCustomerSuccess(state, { payload: idToDelete }) {
      state.customers = state.customers.filter((u) => u.id !== idToDelete);

      if (state.customer && state.customer.id === idToDelete) {
        state.customer = null;
      }

      state.loadingCustomerDelete = false;
      state.errorDeletingCustomer = null;
    },

    setServerResponseStatus(state, { payload }) {
      state.serverStatus = payload;
    },
    setPagination: (state, { payload }) => {
      state.pagination = payload;
    },
  },
});

export const {
  setLoadingCustomers,
  setLoadingCustomer,
  setLoadingCustomerInfo,
  setLoadingCustomerCreate,
  setLoadingCustomerUpdate,
  setLoadingCustomerDelete,

  setErrorLoadingCustomers,
  setErrorLoadingCustomer,
  setErrorLoadingCustomerInfo,
  setErrorCreatingCustomer,
  setErrorUpdatingCustomer,
  setErrorDeletingCustomer,

  setCustomers,
  setCustomer,
  createCustomerSuccess,
  updateCustomerSuccess,
  deleteCustomerSuccess,

  setServerResponseStatus,
  setPagination,
} = customerSlice.actions;

export default customerSlice.reducer;

export const selectCustomer = (state) => state.customer;
